module.exports = __webpack_public_path__ + "img/graduation.037c9624.svg";